import request from '../../../api/request';
import { generatePath } from 'react-router-dom';
import {
  FormDataResponseType,
  PerformanceAnalysisDetailResponseType,
  PerformanceAnalysisPeriodsResponse,
  PerformanceAnalysisResponseType,
} from './types';

const PERFORMANCE_ANALYSIS = {
  PERIODS: `maintainers-portal/management-tools/performance-analysis/periods`,
  FORM_DATA: `maintainers-portal/management-tools/performance-analysis/form-data`,
  LIST: `maintainers-portal/management-tools/performance-analysis/list`,
  LIST_DOWNLOAD: `maintainers-portal/management-tools/performance-analysis/download`,
  DETAIL: (sectionId: number) =>
    generatePath(
      `maintainers-portal/management-tools/performance-analysis/:sectionId`,
      { sectionId },
    ),
  DETAIL_DOWNLOAD: (sectionId: number) =>
    generatePath(
      `maintainers-portal/management-tools/performance-analysis/:sectionId/download`,
      { sectionId },
    ),
};

export async function getPeriods() {
  return request<PerformanceAnalysisPeriodsResponse>(
    PERFORMANCE_ANALYSIS.PERIODS,
    {
      method: 'GET',
    },
  );
}

export async function getFormData(periodId: number) {
  return request<FormDataResponseType>(PERFORMANCE_ANALYSIS.FORM_DATA, {
    method: 'GET',
    params: { periodId },
  });
}

export async function getSections(params: {
  page: number;
  periodId: number;
  studyPlanVersionId?: number;
  courseId?: number;
  sectionId?: number;
  teacherNameOrId?: string;
  studentNameOrId?: string;
}) {
  return request<PerformanceAnalysisResponseType>(PERFORMANCE_ANALYSIS.LIST, {
    method: 'GET',
    params,
  });
}

export async function getSectionDetail(sectionId: number) {
  return request<PerformanceAnalysisDetailResponseType>(
    PERFORMANCE_ANALYSIS.DETAIL(sectionId),
    {
      method: 'GET',
    },
  );
}

export async function downloadSectionDetail(sectionId: number) {
  return request<any>(PERFORMANCE_ANALYSIS.DETAIL_DOWNLOAD(sectionId), {
    method: 'GET',
    responseType: 'blob',
  });
}

export async function downloadSections(params: {
  periodId: number;
  studyPlanVersionId?: number;
  courseId?: number;
  sectionId?: number;
  teacherNameOrId?: string;
  studentNameOrId?: string;
}) {
  return request<any>(PERFORMANCE_ANALYSIS.LIST_DOWNLOAD, {
    method: 'GET',
    responseType: 'blob',
    params,
  });
}
